var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("admin.index_general_description")))]),
      _c("p", [_vm._v(_vm._s(_vm.$t("admin.index_use_cases")))]),
      _c("p", [_vm._v(_vm._s(_vm.$t("admin.index_issues_description")))]),
      _c("br"),
      _c(
        "b-card",
        { attrs: { "no-body": "", header: _vm.headers.consistencyCheck } },
        [
          _c(
            "b-card-body",
            [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("admin.index_consistency_check_description"))
                ),
              ]),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "consistency-check-enabled",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.consistencyCheck.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.consistencyCheck, "enabled", $$v)
                      },
                      expression: "consistencyCheck.enabled",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(_vm.$t("admin.enable_index_consistency_check")) +
                  "\n      "
              ),
              _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "consistency-check-cadence",
                  label: _vm.$t("admin.index_consistency_check_cadence"),
                  "input-group-size": "mb-3",
                  rules: "required|min_value:1",
                  type: "number",
                  tooltip: _vm.consistencyCheck.cadenceTooltip,
                },
                model: {
                  value: _vm.consistencyCheck.cadence,
                  callback: function ($$v) {
                    _vm.$set(_vm.consistencyCheck, "cadence", $$v)
                  },
                  expression: "consistencyCheck.cadence",
                },
              }),
              _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "consistency-check-threshold",
                  label: _vm.$t("admin.index_consistency_check_threshold"),
                  "input-group-size": "mb-3",
                  rules: "required|min_value:1|max_value:100",
                  type: "number",
                  tooltip: _vm.consistencyCheck.thresholdTooltip,
                },
                model: {
                  value: _vm.consistencyCheck.threshold,
                  callback: function ($$v) {
                    _vm.$set(_vm.consistencyCheck, "threshold", $$v)
                  },
                  expression: "consistencyCheck.threshold",
                },
              }),
            ],
            1
          ),
          _c(
            "b-card-footer",
            [
              _c(
                "b-button",
                {
                  staticClass: "px-4",
                  attrs: { size: "md", variant: "outline-primary" },
                  on: { click: _vm.saveConsistencyCheckSettings },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        { attrs: { "no-body": "", header: _vm.headers.manualRebuild } },
        [
          _c(
            "b-card-body",
            [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("admin.index_rebuild_description"))),
              ]),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "project", color: "primary", label: "" },
                    model: {
                      value: _vm.type.project,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "project", $$v)
                      },
                      expression: "type.project",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.reindex_projects")) + "\n      "),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "component", color: "primary", label: "" },
                    model: {
                      value: _vm.type.component,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "component", $$v)
                      },
                      expression: "type.component",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.reindex_components")) + "\n      "),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "vulnerability", color: "primary", label: "" },
                    model: {
                      value: _vm.type.vulnerability,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "vulnerability", $$v)
                      },
                      expression: "type.vulnerability",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(_vm.$t("admin.reindex_vulnerabilities")) + "\n      "
              ),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "vulnerablesoftware",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.type.vulnerablesoftware,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "vulnerablesoftware", $$v)
                      },
                      expression: "type.vulnerablesoftware",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(_vm.$t("admin.reindex_vulnerable_software")) + "\n      "
              ),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "servicecomponent",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.type.servicecomponent,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "servicecomponent", $$v)
                      },
                      expression: "type.servicecomponent",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(_vm.$t("admin.reindex_service_components")) + "\n      "
              ),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "license", color: "primary", label: "" },
                    model: {
                      value: _vm.type.license,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "license", $$v)
                      },
                      expression: "type.license",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.reindex_licenses")) + "\n      "),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "cpe", color: "primary", label: "" },
                    model: {
                      value: _vm.type.cpe,
                      callback: function ($$v) {
                        _vm.$set(_vm.type, "cpe", $$v)
                      },
                      expression: "type.cpe",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.reindex_cpes")) + "\n      "),
              _c("br"),
            ],
            1
          ),
          _c(
            "b-card-footer",
            [
              _c(
                "b-button",
                {
                  staticClass: "px-4",
                  attrs: { size: "md", variant: "outline-primary" },
                  on: { click: _vm.reindex },
                },
                [_vm._v(_vm._s(_vm.$t("message.reindex")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }